$(document).ready(function(){

    $.validator.addMethod("emailwdomain", function(value, element) {
        return this.optional(element) || /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(value) || /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/.test(value);
    }, "Please enter a valid email address.");

    $.validator.addMethod("alpha", function(value, element) {
        return this.optional(element) || value == value.match(/^[a-zA-Z\s]+$/);
    },"Only letters are allowed.");

    $(".validate-contact").validate({
        rules: {
            'contact[email]': {
                emailwdomain: true
            }
        },
        submitHandler: function(form) {
            localStorage.setItem('contactform-success', 'true');
            form.submit();
        }
    });

});